const history = {
  title: 'मेरी परियोजनाएं',
  upgradeBtn: 'अपग्रेड करें',
  subTitle:
    'अपनी फाइल डाउनलोड करना न भूलें क्योंकि यह 72 घंटों के बाद हटा दी जाएगी।',
  MAgo: '{{num}} मिनट पहले',
  HAgo: '{{num}} घंटे पहले',
  DAgo: '{{num}} घंटे पहले',
  justNow: 'अभी-अभी',
  originalFile: 'मूल फाइल',
  selectAllBtn: 'सभी चुनें',
  emptyTips: 'अभी तक कोई परियोजना नहीं है। <1>चलिए संपादित करें</1>',
  deleteTips: 'क्या आप इसे हटाना चाहते हैं?',
};

export default history;
